import React, { useEffect } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import funnel from "../../styles/Funnel.module.css";
import axios from "axios";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { NumericFormat } from "react-number-format";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import { useCookies } from "react-cookie";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import Footer from "../../component/footer";

let CustomSelect = styled(Select)(({ theme }) => ({
  width: "90%",
  "&.MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
});

const NextButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  border: "1px solid var(--primary-color)",
  fontWeight: "600",
  width: "50%",
  height: "45px",
  fontSize: "15px",
  backgroundColor: "var(--primary-color)",
  "&:hover": {
    border: "1px solid var(--primary-color)",
    backgroundColor: "var(--dark-color)",
  },
}));

export default function BuyingChanceFunnel() {
  const [state, setState] = React.useState(null);
  const [suburbList, setSuburbList] = React.useState([]);
  const [formData, setFormData] = React.useState({
    price_mortgage: "",
    price_deposit: "",
    suburb: "",
    suburb_id: "",
    state: null,
    type: 20,
  });
  const [errorm, setErrorm] = React.useState(false);
  const [errord, setErrord] = React.useState(false);
  const [errordn, setErrordn] = React.useState(false);
  const [errors, setErrors] = React.useState(false);
  const [errorsu, setErrorsu] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [authToken, setAuthToken] = React.useState("");
  const [cookies, setCookie, removeCookie] = useCookies([
    "access_token",
    "price_mortgage",
    "price_deposit",
    "state",
    "suburb_id",
    "type",
  ]);
  const Router = useRouter();

  useEffect(() => {
    setAuthToken(cookies.access_token);
  }, []);

  const handleChangeMortgage = (event) => {
    setFormData({
      ...formData,
      price_mortgage: event.target.value,
    });
    setErrorm(false);
  };

  let errorMortgage;
  let helperTextMortgage;
  if (errorm == true) {
    errorMortgage = "error";
    helperTextMortgage = "Mortgage value cannot be empty!";
  } else {
    errorMortgage = "";
    helperTextMortgage = "";
  }

  const handleChangeDeposit = (event) => {
    setFormData({
      ...formData,
      price_deposit: event.target.value,
    });
    setErrord(false);
    setErrordn(false);
  };

  let errorDeposit;
  let helperTextDeposit = "Deposit value must be larger than $20,000.";
  if (errord == true) {
    errorDeposit = "error";
    helperTextDeposit = "Deposit value cannot be empty!";
  } else if (errordn == true) {
    errorDeposit = "error";
    helperTextDeposit = "Deposit value must be larger than $20,000.";
  } else {
    errorDeposit = "";
    helperTextDeposit = "Deposit value must be larger than $20,000.";
  }

  const handleChangeState = (event) => {
    setState(event.target.value);
    setFormData({
      ...formData,
      state: event.target.value,
    });
    axios
      .get(
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/property/suburb/list/${event.target.value}/`
      )
      .then((res) => {
        setSuburbList(res.data);
      })
      .catch((err) => {
        if (err.code == "ERR_NETWORK") {
          Router.push("/error/");
        }
      });
    setErrors(false);
  };

  let helperTextState;
  if (errors == true) {
    CustomSelect = styled(Select)(() => ({
      "&.MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "red",
        },
        "&:hover fieldset": {
          borderColor: "red",
        },
        "&.Mui-focused fieldset": {
          borderColor: "red",
        },
      },
    }));
    helperTextState = "Please select a state!";
  } else {
    CustomSelect = styled(Select)(() => ({
      "&.MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "var(--primary-color)",
        },
        "&:hover fieldset": {
          borderColor: "var(--primary-color)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "var(--primary-color)",
        },
      },
    }));
    helperTextState = "";
  }

  const suburbs = [];
  suburbList.map((name) => {
    suburbs.push({
      title: name.suburb_name + "," + name.state + "," + name.postcode,
      suburb_id: name.suburb_id,
    });
  });

  const handleChangeSuburb = (event, value) => {
    setFormData({
      ...formData,
      suburb_id: value.suburb_id,
    });
    setErrorsu(false);
  };

  let disable_auto;
  if (state === null) {
    disable_auto = "disabled";
  }
  let suItem;
  for (let item in suburbs) {
    if (formData.suburb == suburbs[item].title) {
      suItem = suburbs[item];
    }
  }

  let errorSububr;
  let helperTextSububr;
  if (errorsu == true) {
    errorSububr = "error";
    helperTextSububr = "Suburb value cannot be empty!";
  } else {
    errorSububr = "";
    helperTextSububr = "";
  }

  const data = [
    { value: "act", label: "ACT" },
    { value: "nsw", label: "NSW" },
    { value: "wa", label: "WA" },
    { value: "vic", label: "VIC" },
    { value: "nt", label: "NT" },
    { value: "qld", label: "QLD" },
    { value: "sa", label: "SA" },
    { value: "tas", label: "TAS" },
  ];

  const handleNext = () => {
    if (formData.price_mortgage === "" || formData.price_mortgage.length <= 1) {
      return setErrorm(true);
    } else {
      setCookie("price_mortgage", formData.price_mortgage, { maxAge: 1800 });
      setErrorm(false);
    }

    if (
      (parseInt(formData.price_deposit) <= 19 &&
        formData.price_deposit.length == 6) ||
      formData.price_deposit.length <= 5
    ) {
      return setErrordn(true);
    } else {
      setCookie("price_deposit", formData.price_deposit, { maxAge: 1800 });
      setErrord(false);
      setErrordn(false);
    }

    if (state === null) {
      return setErrors(true);
    } else {
      setCookie("state", formData.state, { maxAge: 1800 });
      setErrors(false);
    }

    if (formData.suburb_id === "" || formData.suburb_id.length <= 1) {
      return setErrorsu(true);
    } else {
      setCookie("suburb_id", formData.suburb_id, { maxAge: 1800 });
      setCookie("type", 20, { maxAge: 1800 });
      setErrorsu(false);
    }

    if (authToken) {
      setLoading(true);
      const data = {
        mortgage: cookies.price_mortgage,
        deposit: cookies.price_deposit,
        state: cookies.state,
        suburb_id: parseInt(cookies.suburb_id),
        type: parseInt(cookies.type),
      };
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      };
      axios
        .post(`${process.env.NEXT_PUBLIC_API_BASE_URL}/property/`, data, {
          headers: headers,
        })
        .then((res) => {
          Router.push("/buying-chance/dashboard/");
        });
    } else {
      Router.push("/register/");
      setLoading(true);
    }
  };

  return (
    <>
      <Head>
        <title>
          Find Your Perfect Property Investment Opportunity by Suburb
        </title>
        <link
          rel="canonical"
          href="https://abodefinder.com.au/buying-chance/"
        ></link>
        <meta
          name="description"
          content="Discover your chances of buying a property in your preferred suburb with our Buying Chance Calculator. Input your financial information and get valuable insights on the current market conditions. Make informed decisions with AbodeFinder"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" type="image/png" sizes="32x32" href="https://abodefinder.com.au/blog-static/img/favicon-32.ico"/>
      </Head>
      <div className={funnel.allFunnel}>
        <div className={funnel.funnelChance}>
          <div className={funnel.funnelBody}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <div className={funnel.boxQn}>
                <h1 className={funnel.h1Text}>
                  Buying Chance Calculator: Determine Your Chance of Buying
                  Property in Your Ideal Suburb
                </h1>
                <h2 className={funnel.h2TextFunnel}>
                  Make Informed Property Investment Decisions with Our Buying
                  Chance Calculator by Suburb
                </h2>
                <div className={funnel.FunnelField}>
                  <h4 className={funnel.h4TextFunnel}>
                    How much mortgage can you get?
                  </h4>
                  <FormControl fullWidth>
                    <NumericFormat
                      error={errorMortgage}
                      helperText={helperTextMortgage}
                      value={formData.price_mortgage}
                      name="price_mortgage"
                      placeholder="example: 10000"
                      onChange={handleChangeMortgage}
                      id="outlined-adornment-amount"
                      thousandSeparator=","
                      customInput={CssTextField}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </div>

                <div className={funnel.FunnelField}>
                  <h4 className={funnel.h4TextFunnel}>
                    How much deposite do you have?
                  </h4>
                  <FormControl fullWidth>
                    <NumericFormat
                      error={errorDeposit}
                      helperText={helperTextDeposit}
                      value={formData.price_deposit}
                      name="price_deposit"
                      placeholder="example: 20000"
                      onChange={handleChangeDeposit}
                      id="outlined-adornment-amount"
                      thousandSeparator=","
                      customInput={CssTextField}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </div>

                <div className={funnel.funnelColumnField}>
                  <h4 className={funnel.h4TextFunnel}>
                    Select your state and more
                  </h4>
                  <div className={funnel.funnelRowField}>
                    <div className={funnel.FunnelFieldState}>
                      <FormControl fullWidth>
                        <InputLabel
                          id="demo-simple-select-label"
                          sx={{
                            "&.Mui-focused": { color: "var(--primary-color)" },
                          }}
                        >
                          State
                        </InputLabel>
                        <CustomSelect
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={state}
                          label="State"
                          onChange={handleChangeState}
                        >
                          {data.map((data) => (
                            <MenuItem value={data.value}>{data.label}</MenuItem>
                          ))}
                        </CustomSelect>
                        <FormHelperText sx={{ color: "red" }}>
                          {helperTextState}
                        </FormHelperText>
                      </FormControl>
                    </div>
                    <div className={funnel.FunnelFieldSuburb}>
                      <FormControl fullWidth>
                        <Autocomplete
                          loading
                          sx={{ margin: 0 }}
                          freeSolo
                          id="highlights-demo"
                          disabled={disable_auto}
                          options={suburbs}
                          onChange={handleChangeSuburb}
                          value={suItem}
                          getOptionLabel={(option) => option.title}
                          renderInput={(params) => (
                            <CssTextField
                              {...params}
                              error={errorSububr}
                              helperText={helperTextSububr}
                              value={formData.suburb_id}
                              placeholder="Suburb"
                              sx={{ mt: 0 }}
                              margin="normal"
                            />
                          )}
                          renderOption={(props, option, { inputValue }) => {
                            const matches = match(option.title, inputValue, {
                              insideWords: true,
                            });
                            const parts = parse(option.title, matches);

                            return (
                              <li {...props}>
                                <div>
                                  {parts.map((part, index) => (
                                    <span
                                      key={index}
                                      style={{
                                        fontWeight: part.highlight ? 700 : 400,
                                      }}
                                    >
                                      {part.text}
                                    </span>
                                  ))}
                                </div>
                              </li>
                            );
                          }}
                        />
                      </FormControl>
                    </div>
                  </div>
                </div>
                <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                  <NextButton
                    variant="contained"
                    onClick={handleNext}
                    sx={{ mt: 3, ml: 1 }}
                  >
                    {loading ? "Loading..." : "Calculate"}
                  </NextButton>
                </Box>
              </div>
            </Box>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
